'use strict';

import CountdownModel from 'standard-vote/app/scripts/models/countdown.js';

module.exports = CountdownModel;



// WEBPACK FOOTER //
// ./app/scripts/models/countdown.js